import { render, staticRenderFns } from "./DurationField.vue?vue&type=template&id=f3eec46c&"
import script from "./DurationField.vue?vue&type=script&lang=js&"
export * from "./DurationField.vue?vue&type=script&lang=js&"
import style0 from "./DurationField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSlider});
